<bic-popup (close)="cancelClicked()" customClass="w-[560px]" title="Speicherlimit überschritten!">
  <div bicPopupContent class="flex flex-col gap-4">
    <span class="text-sm font-semibold text-gray">Kein freier Speicherplatz mehr verfügbar!</span>
    <div class="flex flex-col gap-1">
      <span class="text-sm text-gray font-medium underline">Details:</span>
      <span class="text-sm text-gray">
        Aktuell belegt: <strong>{{ data.usedGb | number:'1.1-2' }} GB</strong> von
        <strong>{{ data.limitGb }} GB</strong>
      </span>
      <span class="text-sm text-gray">
        Die hochzuladenden Dateien benötigen <strong>{{ data.requiredGb | number:'1.1-2' }} GB</strong>,
        es sind jedoch nur noch <strong>{{ data.freeGb | number:'1.1-2' }} GB</strong> verfügbar.
      </span>
    </div>
    <div class="flex flex-col">
      <span class="text-sm text-gray font-medium underline">Hinweis:</span>
      <span class="text-sm text-gray">Bitte löschen Sie nicht mehr benötigte Dateien oder kontaktieren Sie den Support, um Ihr Speicherkontingent zu erhöhen.</span>
    </div>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
    <bic-button (onClick)="cancelClicked()" buttonType="white">Schließen</bic-button>
  </div>
</bic-popup>
